import { LoggerOptions } from "../Logger/Logger";

export const getDefaultLoggerOptions: () => LoggerOptions = () => ({
    level: "ERROR"
});
